import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";

import Grow from '@mui/material/Grow';
import Paper from '@mui/material/Paper';
import Popper from '@mui/material/Popper';

import LookSideBarShareButtons from "./lookSideBarShareButtons";

const LookSideBarShareModal = (props) => {

  const {handleClose, shareModalOpened, anchorEl, windowHeight} = props;

  return (
    <Popper open={shareModalOpened}
            className="look-sidebar__modal look-sidebar__modal--secondary"
            id={"sidebar-modal"}
            anchorEl={anchorEl.current}
            placement={windowHeight < 420 ? "right-end" : "right-start"}
            transition
            disablePortal={false}>
      {({ TransitionProps }) => (
        <Grow
          {...TransitionProps}
          style={{ transformOrigin: "left center" }}
        >
          <Paper>
            <LookSideBarShareButtons handleClose={handleClose}/>
          </Paper>
        </Grow>
      )}
    </Popper>
  )
};

LookSideBarShareModal.propTypes = {
  handleClose: PropTypes.func.isRequired,
  shareModalOpened: PropTypes.bool.isRequired
}

const mapStateToProps = (store) => {
  const {windowHeight} = store.serverState;
  return {
    windowHeight,
  };
};

export default connect(mapStateToProps)(LookSideBarShareModal)
